import type { PromoCodeSortColumn } from 'types';

export enum PromoCodeDiscountType {
    VALUE = 'value',
    PERCENTAGE_DISCOUNT = 'percentage_discount',
    MINUTES_TO_DISCOUNT = 'minutes_to_discount',
    RATE_OVERRIDE = 'rate_override',
}

// Fields the promo code list can be ordered by (see PromoCodeViewSet.ordering_fields).
export const PROMO_CODE_SORT_COLUMNS: readonly PromoCodeSortColumn[] = ['code', 'notes', 'uses_left'];
